<template>
  <div class="bottom-bar-animation pointer-events-none w-full">
    <div
      :aria-hidden="true"
      class="absolute inset-0 -z-10 bg-linear-to-t from-White from-65% to-transparent"
    ></div>
    <div>
      <div
        class="clip-path-animate absolute -top-[1.6vw] flex w-full justify-around text-White"
        aria-label="hidden"
      >
        <IconPill class="m-[6%] grow translate-x-[5.5vw]" />
        <IconDrip class="m-[6%] grow translate-x-[1.6vw]" />
        <IconHomeLogoSiluette class="m-[6%] grow -translate-x-[1.6vw]" />
        <IconInfo class="m-[6%] grow -translate-x-[2.6vw]" />
        <IconGearwheel class="m-[6%] grow -translate-x-[6.4vw]" />
      </div>
    </div>
    <svg
      class="w-full"
      viewBox="1 -30 374 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        :cx="currentCirclePosition"
        cy="2"
        r="25.5"
        class="circle-animation"
        fill="#29418F"
      />
      <path class="path-animation" :d="currentPath" fill="#29418F" />
    </svg>
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n()

const props = defineProps<{
  index: number
}>()

// SAAAFFAARRII!!! 🤮

const paths = [
  'M59.454 35.8696C71.85 35.8696 82.744 29.418 88.974 19.6817C94.928 10.378 103.455 0.739136 114.5 0.739136H353.596C365.693 0.739136 375.5 10.5694 375.5 22.6957V57.2174C375.5 62.0679 371.577 66 366.738 66H9.26168C4.42274 66 0.5 62.0679 0.5 57.2174V27.5C0.5 15.3737 6.5958 6.5 16.5 6.5H18.5C24 6.5 23.9793 10.378 29.9331 19.6817C36.1638 29.418 47.057 35.8696 59.454 35.8696Z',
  'M118.283 35.8696C130.679 35.8696 141.573 29.418 147.803 19.6817C153.757 10.378 162.284 0.739136 173.329 0.739136H353.096C365.193 0.739136 375 10.5694 375 22.6957V57.2174C375 62.0679 371.077 66 366.238 66H8.76168C3.92274 66 0 62.0679 0 57.2174V22.6957C0 10.5694 9.80685 0.739136 21.9042 0.739136H63.236C74.2817 0.739136 82.8083 10.378 88.7621 19.6817C94.9928 29.418 105.886 35.8696 118.283 35.8696Z',
  'M181.367 35.8696C193.763 35.8696 204.657 29.418 210.887 19.6817C216.841 10.378 225.368 0.739136 236.414 0.739136H353.096C365.193 0.739136 375 10.5694 375 22.6957V57.2174C375 62.0679 371.077 66 366.238 66H8.76168C3.92274 66 0 62.0679 0 57.2174V22.6957C0 10.5694 9.80685 0.739136 21.9042 0.739136H126.32C137.366 0.739136 145.892 10.3779 151.846 19.6817C158.077 29.418 168.97 35.8696 181.367 35.8696Z',
  'M253.213 35.8696C265.609 35.8696 276.503 29.418 282.733 19.6817C288.687 10.378 297.214 0.739136 308.259 0.739136H353.096C365.193 0.739136 375 10.5694 375 22.6957V57.2174C375 62.0679 371.077 66 366.238 66H8.76168C3.92274 66 0 62.0679 0 57.2174V22.6957C0 10.5694 9.80685 0.739136 21.9042 0.739136H198.166C209.212 0.739136 217.738 10.378 223.692 19.6817C229.923 29.418 240.816 35.8696 253.213 35.8696Z',
  'M313.48 35.8696C325.876 35.8696 336.77 29.418 343 19.6817C348.954 10.378 347.955 5.54344 359 5.54344H360C372.097 5.54344 375 15.3737 375 27.5V57.2174C375 62.0679 371.077 66 366.238 66H8.76168C3.92274 66 0 62.0679 0 57.2174V22.6957C0 10.5694 9.80685 0.739136 21.9042 0.739136H258.433C269.479 0.739136 278.005 10.378 283.959 19.6817C290.19 29.418 301.083 35.8696 313.48 35.8696Z',
]

const circlePosition = [59, 119, 182, 253, 314]

const currentPath = computed(() => paths[props.index])
const currentCirclePosition = computed(() => circlePosition[props.index])
</script>

<style scoped>
.path-animation {
  transition: d 0.5s;
}

.circle-animation {
  transition: cx 0.5s;
}

.clip-path-animate {
  transition: clip-path 0.5s;
}

.bottom-bar-animation[data-index='0'] {
  .circle-animation {
    cx: 59;
  }

  .clip-path-animate {
    clip-path: circle(9% at 15.5%);
  }

  .path-animation {
    d: path(
      'M59.454 35.8696C71.85 35.8696 82.744 29.418 88.974 19.6817C94.928 10.378 103.455 0.739136 114.5 0.739136H353.596C365.693 0.739136 375.5 10.5694 375.5 22.6957V57.2174C375.5 62.0679 371.577 66 366.738 66H9.26168C4.42274 66 0.5 62.0679 0.5 57.2174V27.5C0.5 15.3737 6.5958 6.5 16.5 6.5H18.5C24 6.5 23.9793 10.378 29.9331 19.6817C36.1638 29.418 47.057 35.8696 59.454 35.8696Z'
    );
  }
}

.bottom-bar-animation[data-index='1'] {
  .circle-animation {
    cx: 119;
  }

  .clip-path-animate {
    clip-path: circle(9% at 32%);
  }

  .path-animation {
    d: path(
      'M118.283 35.8696C130.679 35.8696 141.573 29.418 147.803 19.6817C153.757 10.378 162.284 0.739136 173.329 0.739136H353.096C365.193 0.739136 375 10.5694 375 22.6957V57.2174C375 62.0679 371.077 66 366.238 66H8.76168C3.92274 66 0 62.0679 0 57.2174V22.6957C0 10.5694 9.80685 0.739136 21.9042 0.739136H63.236C74.2817 0.739136 82.8083 10.378 88.7621 19.6817C94.9928 29.418 105.886 35.8696 118.283 35.8696Z'
    );
  }
}

.bottom-bar-animation[data-index='2'] {
  .circle-animation {
    cx: 182;
  }

  .clip-path-animate {
    clip-path: circle(9% at 48%);
  }

  .path-animation {
    d: path(
      'M181.367 35.8696C193.763 35.8696 204.657 29.418 210.887 19.6817C216.841 10.378 225.368 0.739136 236.414 0.739136H353.096C365.193 0.739136 375 10.5694 375 22.6957V57.2174C375 62.0679 371.077 66 366.238 66H8.76168C3.92274 66 0 62.0679 0 57.2174V22.6957C0 10.5694 9.80685 0.739136 21.9042 0.739136H126.32C137.366 0.739136 145.892 10.3779 151.846 19.6817C158.077 29.418 168.97 35.8696 181.367 35.8696Z'
    );
  }
}

.bottom-bar-animation[data-index='3'] {
  .circle-animation {
    cx: 253;
  }

  .clip-path-animate {
    clip-path: circle(9% at 67%);
  }

  .path-animation {
    d: path(
      'M253.213 35.8696C265.609 35.8696 276.503 29.418 282.733 19.6817C288.687 10.378 297.214 0.739136 308.259 0.739136H353.096C365.193 0.739136 375 10.5694 375 22.6957V57.2174C375 62.0679 371.077 66 366.238 66H8.76168C3.92274 66 0 62.0679 0 57.2174V22.6957C0 10.5694 9.80685 0.739136 21.9042 0.739136H198.166C209.212 0.739136 217.738 10.378 223.692 19.6817C229.923 29.418 240.816 35.8696 253.213 35.8696Z'
    );
  }
}

.bottom-bar-animation[data-index='4'] {
  .circle-animation {
    cx: 314;
  }

  .clip-path-animate {
    clip-path: circle(9% at 84%);
  }

  .path-animation {
    d: path(
      'M313.48 35.8696C325.876 35.8696 336.77 29.418 343 19.6817C348.954 10.378 347.955 5.54344 359 5.54344H360C372.097 5.54344 375 15.3737 375 27.5V57.2174C375 62.0679 371.077 66 366.238 66H8.76168C3.92274 66 0 62.0679 0 57.2174V22.6957C0 10.5694 9.80685 0.739136 21.9042 0.739136H258.433C269.479 0.739136 278.005 10.378 283.959 19.6817C290.19 29.418 301.083 35.8696 313.48 35.8696Z'
    );
  }
}
</style>
